module.exports = __webpack_public_path__ + "static/media/crybaby.153929f3.jpg";